﻿//Bootstrap JS
import * as bootstrap from 'bootstrap';

//animate on scroll (aos)
import AOS from 'aos';
import 'aos/dist/aos.css';

//GSAP
import { scrollCarousel } from './gsap';

AOS.init();

//global
const body = document.body;

//mobile menu
const mobileToggle = document.getElementById("toggle-menu");
const mobileOverlay = document.getElementById("mobile-overlay");

mobileToggle.addEventListener("click", () => {
    mobileOverlay.style.display = mobileToggle.checked ? "block" : "none";
    body.classList.toggle("overflow-hidden", mobileToggle.checked);
});

mobileOverlay.addEventListener("click", removeOverlay);

window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    if (windowWidth >= 768) {
        removeOverlay();
    }
});
function removeOverlay() {
    body.classList.remove("overflow-hidden");
    mobileOverlay.style.display = "none";
    mobileToggle.checked = false;
}

//contact us
let contactForm = document.getElementById('contact-form');
var enquiryType = document.getElementById('Enquiry');
var companyName = document.getElementById('companyInputRow');

if (contactForm){
    window.onload = () => {
        inputHide();
    }
    contactForm.addEventListener('change', () =>{
        inputHide();
    })
    function inputHide(){
        if(enquiryType.value !== 'Brokers'){
            companyName.classList.add("d-none");
        }
        else{
            companyName.classList.remove("d-none");
        }
    }
}

//gsap
scrollCarousel();